import React from 'react';
import { IntlMessagesProvider } from '@atlaskit/intl-messages-provider';
import en from '../../../i18n/en';
import { fetchMessagesForLocale } from './utils/fetch-messages-for-locale';
export var LazyMessagesProvider = function LazyMessagesProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(IntlMessagesProvider, {
    defaultMessages: en,
    loaderFn: fetchMessagesForLocale
  }, children);
};